import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice.js';

/**
 * Серверден келген маалымат (долбоорлор, главалар) Redux'ка салынбайт —
 * ар экран өзү жүктөйт (`useLoad`). Redux'та колдонуучу гана: ал бардык
 * экранга керек (аты, укуктары, интерфейстин жөндөөлөрү).
 */
export const store = configureStore({
  reducer: { auth: authReducer },
});
